import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { publicEventApi } from 'src/app/services/constants/api.constants';
import { HttpBaseService } from '@evento-ng/libs';
import { TicketService } from 'src/app/services/ticket.service';

@Component({
  selector: 'app-new-booking',
  templateUrl: './new-booking.component.html',
  styleUrls: ['./new-booking.component.scss'],
})
export class NewBookingComponent {
  eventId: any;
  event: any;
  showCustomForm = false;
  showInfoForm = false;
  customFormDetails: any;
  showReview = false;
  showCartMobile = false;
  isMobile = false;
  invoice: any = null;
  constructor(
    private route: ActivatedRoute,
    private dataService: HttpBaseService,
    private ticketService: TicketService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {
    this.ticketService.bookTicket.next(null);
    this.route.queryParams.subscribe((res) => {
      this.eventId = res['eventId'];
    });
  }

  ngOnInit() {
    this.getEventDetails();
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
  }

  setCartMobile(value: any) {
    this.showCartMobile = value;
  }

  getEventDetails() {
    this.spinner.show();
    this.dataService
      .get(`${publicEventApi}/${this.eventId}`)
      .subscribe((res) => {
        this.event = res;
        this.spinner.hide();
      });
  }

  goToCustomForm(event: any) {
    this.customFormDetails = event;
    this.showCustomForm = true;
  }

  goToInfoForm(event: any) {
    this.showCustomForm = false;
    this.showInfoForm = true;
  }

  goToReview() {
    this.showCustomForm = false;
    this.showInfoForm = false;
    this.showReview = true;
  }
}
